import { CloudUploadOutlined } from '@vindr/icons';
import { Button } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import { useCaptureManagerState } from '../context';
import { useEffect, useState } from 'react';

const UploadIcon = () => {
  const { t } = useTranslation('Vindoc');
  const { selected, handleUploadFiles, processingList } = useCaptureManagerState();

  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    setDisabled(
      isEmpty(selected) ||
        selected.every(
          (it) =>
            ['success', 'converting', 'uploading'].includes(processingList.get(it.id).status) ||
            (it.tag === 'video' && !it.name.endsWith('.mp4'))
        )
    );
  }, [processingList, selected]);

  return (
    <Button
      className="flex items-center text-3xl"
      type="primary"
      title={t('Upload Files')}
      onClick={() => (setDisabled(true), handleUploadFiles())}
      disabled={disabled}
      icon={<CloudUploadOutlined />}
    >
      <span className="text-base">{t('Upload')}</span>
    </Button>
  );
};

export default UploadIcon;
